<template>
  <div :class="['ai-session-list', collapsed ? 'list-collapsed' : 'list-expanded']" :style="listStyle">
    <div v-if="!collapsed" class="list-content">
      <div class="list-header">
        <span class="list-title">历史会话</span>
        <span class="collapse-btn" @click.stop="toggleCollapse" title="收起侧边栏">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#6B7280" stroke-width="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </span>
      </div>
      <div class="new-chat-btn" @click="createSession">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#2BBD6E" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
        <span>新建对话</span>
      </div>
      <div class="session-scroll">
        <template v-for="(group, gIdx) in groupedSessions">
          <div :key="'g-' + gIdx" class="time-group">
            <div class="group-label">{{ group.label }}</div>
            <div
              v-for="session in group.sessions"
              :key="session.sessionId"
              :class="['session-item', { active: session.sessionId === currentSessionId }]"
              @click="selectSession(session)"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0">
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
              </svg>
              <span class="session-title-text">{{ session.title || '新对话' }}</span>
              <span
                v-if="session.sessionId === currentSessionId"
                class="delete-session"
                @click.stop="deleteSession(session)"
                title="删除会话"
              >&times;</span>
            </div>
          </div>
        </template>
        <div v-if="sessions.length === 0 && !loading" class="no-sessions">暂无会话</div>
      </div>
    </div>
    <div v-else class="collapsed-icons" @click="toggleCollapse" title="展开会话列表">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2BBD6E" stroke-width="2">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiSessionList',
  props: {
    sessions: { type: Array, default: function() { return [] } },
    currentSessionId: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    listWidth: { type: Number, default: 0 }
  },
  data() {
    return {
      collapsed: false
    }
  },
  computed: {
    listStyle() {
      if (this.collapsed || !this.listWidth) return {}
      return { width: this.listWidth + 'px' }
    },
    groupedSessions() {
      var groups = {}
      var now = new Date()
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      var oneDayAgo = new Date(today.getTime() - 86400000)
      var oneWeekAgo = new Date(today.getTime() - 7 * 86400000)
      var oneMonthAgo = new Date(today.getTime() - 30 * 86400000)
      var order = ['今天', '昨天', '一周前', '一个月前', '更早']
      order.forEach(function(k) { groups[k] = [] })
      var vm = this
      this.sessions.forEach(function(s) {
        var ct = new Date(s.createTime)
        var label
        if (ct >= today) { label = '今天' }
        else if (ct >= oneDayAgo) { label = '昨天' }
        else if (ct >= oneWeekAgo) { label = '一周前' }
        else if (ct >= oneMonthAgo) { label = '一个月前' }
        else { label = '更早' }
        if (!groups[label]) groups[label] = []
        groups[label].push(s)
      })
      var result = []
      order.forEach(function(k) {
        if (groups[k] && groups[k].length > 0) {
          result.push({ label: k, sessions: groups[k] })
        }
      })
      return result
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed
      this.$emit('collapse-change', this.collapsed)
    },
    createSession() {
      this.$emit('create-session')
    },
    selectSession(session) {
      // 如果侧边栏已收起，点击会话项时自动展开
      if (this.collapsed) {
        this.collapsed = false
        this.$emit('collapse-change', false)
      }
      this.$emit('select-session', session)
    },
    deleteSession(session) {
      this.$emit('delete-session', session)
    }
  }
}
</script>

<style scoped>
.ai-session-list {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
}
.list-expanded { min-width: 150px; }
.list-collapsed { width: 48px; }
.list-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px 8px;
}
.list-title {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
}
.collapse-btn {
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
}
.collapse-btn:hover { background: #F3F4F6; }
.new-chat-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  margin: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #2BBD6E;
  transition: background 0.2s;
}
.new-chat-btn:hover { background: rgba(43, 189, 110, 0.08); }
.session-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 4px 8px;
}
.session-scroll::-webkit-scrollbar { width: 3px; }
.session-scroll::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 3px; }
.time-group { margin-bottom: 8px; }
.group-label {
  font-size: 11px;
  color: #9CA3AF;
  padding: 4px 8px;
  text-transform: uppercase;
}
.session-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  color: #6B7280;
  position: relative;
}
.session-item:hover { background: rgba(43, 189, 110, 0.06); }
.session-item.active {
  background: rgba(43, 189, 110, 0.1);
  color: #2BBD6E;
}
.session-title-text {
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.delete-session {
  font-size: 18px;
  color: #9CA3AF;
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.2s, color 0.2s;
}
.session-item:hover .delete-session { opacity: 1; }
.delete-session:hover { color: #EF4444; }
.no-sessions {
  text-align: center;
  color: #9CA3AF;
  font-size: 13px;
  padding: 20px;
}
.collapsed-icons {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px 0;
  cursor: pointer;
  transition: background 0.2s;
  background: rgba(255, 255, 255, 0.7);
}
.collapsed-icons:hover { background: rgba(43, 189, 110, 0.1); }
</style>
